import '@/store/api/product-inventory/typedefs'
import api from '@/store/api/product-inventory'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    productCategory: {}
})

const state = initialState()

export default {
    namespaced: true,
    state,
    getters: {
        productCategory: state => state.productCategory
    },
    actions: {
        /**
         * @param {ProductQuery} data
         * @returns {Promise<*>}
         */
        showProductCategory: async ({commit, dispatch}, data) => {
            try {
                const response = await api.productCategories.showProductCategory(data)
                commit(mutationTypes.SET_PRODUCT_CATEGORY, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {Category} data
         * @returns {Promise<*>}
         */
        createProductCategory: async ({dispatch}, data) => {
            try {
                return await api.productCategories.createProductCategory(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {Category} data
         * @returns {Promise<*>}
         */
        updateProductCategory: async ({dispatch}, data) => {
            try {
                return await api.productCategories.updateProductCategory(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {Category} data
         * @returns {Promise<*>}
         */
        removeProductCategory: async ({dispatch}, data) => {
            try {
                return await api.productCategories.removeProductCategory(data)
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetProductCategory: async ({commit}) => commit(mutationTypes.RESET_PRODUCT_CATEGORY)
    },
    mutations: {
        [mutationTypes.SET_PRODUCT_CATEGORY]: (state, data) => state.productCategory = data,
        [mutationTypes.RESET_PRODUCT_CATEGORY]: (state) => Object.assign(state, initialState())
    }
}
